import '../assets/NcMentionBubble-7PQ8wEko.css';
import '../assets/NcHeaderMenu-BKufmJd0.css';
import { vOnClickOutside as n } from "@vueuse/components";
import { createFocusTrap as o } from "focus-trap";
import { G as s } from "./GenRandomId-BW3iYFf9.mjs";
import a from "../Mixins/clickOutsideOptions.mjs";
import "../Composables/useIsFullscreen.mjs";
import "../Composables/useIsMobile.mjs";
import "@nextcloud/router";
/* empty css                                                                          */
import { n as c } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import "linkify-string";
import "escape-html";
import "striptags";
import "vue";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/capabilities";
import { g as u } from "./focusTrap-Be9GEB5C.mjs";
import d from "../Components/NcButton.mjs";
const l = {
  name: "NcHeaderMenu",
  components: {
    NcButton: d
  },
  directives: {
    ClickOutside: n
  },
  mixins: [
    a
  ],
  props: {
    /**
     * Unique id for this menu
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * aria-label attribute of the menu open button
     */
    ariaLabel: {
      type: String,
      default: ""
    },
    /**
     * Current menu open state
     */
    open: {
      type: Boolean,
      default: !1
    },
    /**
     * Pass `true` if the header menu is used for website navigation
     *
     * The wrapper tag will be set to `nav` and its `aria-labelledby`
     * will be associated with the menu open button
     */
    isNav: {
      type: Boolean,
      default: !1
    },
    /**
     * Additional visually hidden description text for the menu
     * open button
     */
    description: {
      type: String,
      default: null
    }
  },
  emits: [
    "close",
    "closed",
    "open",
    "opened",
    "update:open",
    "cancel"
  ],
  data() {
    var t, e, i;
    return {
      focusTrap: null,
      opened: this.open,
      shortcutsDisabled: (i = (e = (t = window.OCP) == null ? void 0 : t.Accessibility) == null ? void 0 : e.disableKeyboardShortcuts) == null ? void 0 : i.call(e),
      triggerId: s(),
      descriptionId: s()
    };
  },
  computed: {
    wrapperTag() {
      return this.isNav ? "nav" : "div";
    },
    clickOutsideConfig() {
      return [
        this.closeMenu,
        this.clickOutsideOptions
      ];
    },
    listeners() {
      return this.isNav ? {
        focusout: this.onFocusOut
      } : null;
    }
  },
  watch: {
    open(t) {
      t ? this.openMenu() : this.closeMenu();
    }
  },
  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
  },
  methods: {
    /**
     * Toggle the current menu open state
     */
    toggleMenu() {
      this.opened ? this.closeMenu() : this.openMenu();
    },
    /**
     * Close the current menu
     *
     * @param {boolean} cancelled emit a cancel event instead of close
     */
    closeMenu(t = !1) {
      this.opened = !1, this.$emit(t ? "cancel" : "close"), this.$emit("update:open", !1), this.clearFocusTrap(), this.$nextTick(() => {
        this.$emit("closed");
      });
    },
    /**
     * Open the current menu
     */
    openMenu() {
      this.opened = !0, this.$emit("open"), this.$emit("update:open", !0), this.$nextTick(() => {
        this.useFocusTrap(), this.$emit("opened");
      });
    },
    onKeyDown(t) {
      this.shortcutsDisabled || !this.opened || t.key === "Escape" && (t.preventDefault(), this.closeMenu(!0));
    },
    /**
     * @param {FocusEvent} event The focus event
     */
    onFocusOut(t) {
      this.$refs.headerMenu.contains(t.relatedTarget) || this.closeMenu();
    },
    /**
     * Add focus trap for accessibility.
     * Shall only be used when all children are mounted
     * and available in the DOM. We use $nextTick for that.
     */
    async useFocusTrap() {
      if (this.isNav || this.focusTrap)
        return;
      const t = this.$refs.content;
      this.focusTrap = o(t, {
        allowOutsideClick: !0,
        trapStack: u(),
        fallbackFocus: this.$refs.trigger
      }), this.focusTrap.activate();
    },
    clearFocusTrap() {
      var t;
      (t = this.focusTrap) == null || t.deactivate(), this.focusTrap = null;
    }
  }
};
var p = function() {
  var e = this, i = e._self._c;
  return i(e.wrapperTag, e._g({ directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.clickOutsideConfig, expression: "clickOutsideConfig" }], ref: "headerMenu", tag: "component", staticClass: "header-menu", class: { "header-menu--opened": e.opened }, attrs: { id: e.id, "aria-labelledby": e.isNav ? e.triggerId : null } }, e.listeners), [i("NcButton", { ref: "trigger", staticClass: "header-menu__trigger", attrs: { id: e.isNav ? e.triggerId : null, type: "tertiary-no-background", "aria-label": e.ariaLabel, "aria-describedby": e.description ? e.descriptionId : null, "aria-controls": "header-menu-".concat(e.id), "aria-expanded": e.opened.toString() }, on: { click: function(r) {
    return r.preventDefault(), e.toggleMenu.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e._t("trigger")];
  }, proxy: !0 }], null, !0) }), e.description ? i("span", { staticClass: "header-menu__description hidden-visually", attrs: { id: e.descriptionId } }, [e._v(" " + e._s(e.description) + " ")]) : e._e(), i("div", { directives: [{ name: "show", rawName: "v-show", value: e.opened, expression: "opened" }], staticClass: "header-menu__carret" }), i("div", { directives: [{ name: "show", rawName: "v-show", value: e.opened, expression: "opened" }], staticClass: "header-menu__wrapper", attrs: { id: "header-menu-".concat(e.id) } }, [i("div", { ref: "content", staticClass: "header-menu__content" }, [e._t("default")], 2)])], 1);
}, m = [], h = /* @__PURE__ */ c(
  l,
  p,
  m,
  !1,
  null,
  "7103b917",
  null,
  null
);
const I = h.exports;
export {
  I as N
};
